export default __webpack_public_path__ + "assets/demographics.mp4";